import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Tag from 'primevue/tag'
import Dropdown from 'primevue/dropdown'
import Toast from 'primevue/toast'
import FileUpload from 'primevue/fileupload'
import ConfirmDialog from 'primevue/confirmdialog'
import router from './router'
import './style.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'primevue/resources/themes/lara-light-green/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import App from './App.vue'
import { auth } from '@/firebase'
import { onAuthStateChanged } from 'firebase/auth'

console.log('[Main] Starting application...')

// Verificar se as variáveis de ambiente estão carregadas
console.log('[Main] Checking environment variables...')
const requiredEnvVars = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID'
]

const missingEnvVars = requiredEnvVars.filter(varName => !import.meta.env[varName])
if (missingEnvVars.length > 0) {
  console.error('[Main] Missing environment variables:', missingEnvVars)
  throw new Error('Missing required environment variables')
}

// Initialize Firebase Auth
let app: ReturnType<typeof createApp>

// Wait for Firebase Auth to initialize before mounting the app
onAuthStateChanged(auth, (user) => {
  console.log('[Main] Auth state changed:', user ? 'User logged in' : 'No user')
  
  if (!app) {
    console.log('[Main] Creating Vue app...')
    app = createApp(App)
    
    // Configure plugins
    app.use(createPinia())
    app.use(router)
    app.use(PrimeVue, { ripple: true })
    app.use(ToastService)
    app.use(ConfirmationService)

    // Register PrimeVue components globally
    app.component('Toast', Toast)
    app.component('Dialog', Dialog)
    app.component('Button', Button)
    app.component('DataTable', DataTable)
    app.component('Column', Column)
    app.component('InputText', InputText)
    app.component('FileUpload', FileUpload)
    app.component('ConfirmDialog', ConfirmDialog)
    app.component('Tag', Tag)
    app.component('Dropdown', Dropdown)
    app.component('Accordion', Accordion)
    app.component('AccordionTab', AccordionTab)

    // Register directives
    app.directive('tooltip', Tooltip)

    console.log('[Main] Mounting app...')
    app.mount('#app')
    console.log('[Main] App mounted successfully!')
  }
})